<div class="request-view-modal"
  *renderingPermissionDirective="['BulkSettingRequester', 'BulkSettingReviewer', 'BulkSettingReader']">

  <div class="request-view-modal__header">
    <span class="request-view-modal__header__label">Request {{ requestId }}</span>
    <button class="lx-icon lx-close-x request-view-modal__header__close float-end" (click)="cancel()"></button>

  </div>

  <ng-template #loadingTemplate>
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </ng-template>

  <div class="request-view-modal__body" *ngIf="!loading; else loadingTemplate">
    <div class="request-view-modal__body__field">
      <span class="request-view-modal__body__status__label">{{ settingsUpdateRequest.status }}</span>
    </div>

    <div class="request-view-modal__body__settings">
      <table>
        <thead>
          <tr>
            <th>Setting</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let setting of settings">
            <td>{{setting.name | settingName}}</td>
            <td>{{setting.displayValue}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="request-view-modal__body__field">
      <label for="request-date">Request Date</label>
      <div class="request-view-modal__body__request-date__value" id="request-date">
        {{ requestDate }}
      </div>
    </div>

    <div class="request-view-modal__body__field">
      <label for="requester">Requester Name</label>
      <div class="request-view-modal__body__requester__value" id="requester">
        {{ settingsUpdateRequest.requester || '' }}
      </div>
    </div>

    <div class="request-view-modal__body__field">
      <label for="description">Description</label>
      <div class="request-view-modal__body__description__value" id="description">
        {{ settingsUpdateRequest.description || '' }}
      </div>
    </div>

    <div class="request-view-modal__body__review" *ngIf="reviews">
      <div class="request-view-modal__body__review__values">
        <label for="date">Review Date</label>
        <div class="request-view-modal__body__review__field" id="date">
          {{ reviewDate }}
        </div>
      </div>
      <div class="request-view-modal__body__review__values">
        <label for="reviewer">Reviewer</label>
        <div class="request-view-modal__body__review__field" id="reviewer">
          {{ reviews[0].reviewer || '' }}
        </div>
      </div>
      <div class="request-view-modal__body__review__values">
        <label for="description">Review Description</label>
        <div class="request-view-modal__body__review__field" id="description">
          {{ reviews[0].description || '' }}
        </div>
      </div>
    </div>
    <display-entities [entities]="entitiesList" ></display-entities>
  </div>
  <div class="request-creation-modal__footer d-flex justify-content-center">
    <button class="lx-btn lx-btn-secondary" type="button" (click)="cancel()">Close</button>
  </div>
</div>
